import { ButtonProps } from "components/Button/Button";
import { CSSProperties, FC, ReactElement } from "react";
import Style from "./ButtonGroup.module.css";

export type ButtonGroupProps = {
	children: (ReactElement<ButtonProps> | boolean | undefined)[];
	direction: "horizontal";
};

const ButtonGroup: FC<ButtonGroupProps> = ({ children }) => {
	const childrenCount = children.filter((child) => Boolean(child)).length;
	const style = {
		"--button-group-children-count": childrenCount,
	} as CSSProperties;

	return (
		<div style={style} className={Style.buttonGroup}>
			{children}
		</div>
	);
};

export default ButtonGroup;
